// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_ex-a";
export var fulfillmentFormRail = "_ex-9";
export var headerTitleRow = "_ex-c";
export var orderDetailsWrapper = "_ex-7";
export var orderLinkTrigger = "_ex-2";
export var paymentInformationGrid = "_ex-h";
export var paymentSummaryColumn = "_ex-i";
export var shipmentContainer = "_ex-b";
export var shipmentDetailsMainPane = "_ex-8";
export var shipmentNavigationCard = "_ex-5";
export var shipmentNavigationRail = "_ex-3";
export var shipmentNavigationRailHeader = "_ex-4";
export var shipmentSummaryFact = "_ex-e";
export var shipmentSummaryGrid = "_ex-d";
export var shipmentSummaryMetadataRow = "_ex-f";
export var shipmentSummaryTags = "_ex-g";
export var shipmentWorkspace = "_ex-0";
export var shipmentWorkspaceContent = "_ex-6";
export var shipmentWorkspaceHeader = "_ex-1";